import { Outlet, Link, NavLink } from "react-router-dom";
import Footer from "../Footer/Footer";
import styles from "./Navbar.module.css";
import logo from "../../images/logo.png";

export default function Navbar() {

    const navbarStyle = {
        color: "#4878cf"
    }

    const showMenu = () => {
        const mobileMenu = document.querySelector(`.${styles.mobileMenu}`);
        const navLinks = document.querySelector(`.${styles.navLinks}`);

        mobileMenu.classList.toggle(styles.active);
        navLinks.classList.toggle(styles.active);
    }

    const closeMenu = () => {
        const mobileMenu = document.querySelector(`.${styles.mobileMenu}`);
        const navLinks = document.querySelector(`.${styles.navLinks}`);

        mobileMenu.classList.remove(styles.active);
        navLinks.classList.remove(styles.active);
    }

    return (
        <div>
            <header>
                <div className="container">
                    <nav className={styles.navbar}>
                        <div className={styles.logo}>
                            <Link to="/">
                                <img src={logo} alt="CloTech AI - Custom CRM Solutions Company Logo" />
                            </Link>
                        </div>

                        <ul className={styles.navLinks}>
                            <li><NavLink style={({ isActive }) => (isActive ? navbarStyle : undefined)} onClick={closeMenu} to="/">Home</NavLink></li>
                            <li><NavLink style={({ isActive }) => (isActive ? navbarStyle : undefined)} onClick={closeMenu} to="/about">About Us</NavLink></li>
                            <li><NavLink style={({ isActive }) => (isActive ? navbarStyle : undefined)} onClick={closeMenu} to="/services">Services</NavLink></li>
                            <li><NavLink style={({ isActive }) => (isActive ? navbarStyle : undefined)} onClick={closeMenu} to="/plans">Plans</NavLink></li>
                            <li><NavLink style={({ isActive }) => (isActive ? navbarStyle : undefined)} onClick={closeMenu} to="/careers">Careers</NavLink></li>
                            <li><NavLink style={({ isActive }) => (isActive ? navbarStyle : undefined)} onClick={closeMenu} to="/contact">Contact Us</NavLink></li>

                            {/* Mobile Auth Buttons */}
                            <div className={styles.mobileAuthButtons}>
                                <Link to="https://crm.clotechai.com/login" className="btn btn-primary" onClick={closeMenu}>Login</Link>
                                <Link to="https://crm.clotechai.com/signup" className="btn btn-primary" onClick={closeMenu}>Sign Up</Link>
                            </div>
                        </ul>

                        <div className={styles.authButtons}>
                            <Link to="https://crm.clotechai.com/login" className="btn btn-outline">Login</Link>
                            <Link to="https://crm.clotechai.com/signup" className="btn btn-primary">Sign Up</Link>
                        </div>

                        <div className={styles.mobileMenu} onClick={showMenu}>
                            <i className="fas fa-bars"></i>
                        </div>
                    </nav>
                </div>
            </header>
            <Outlet />
            <Footer />
        </div>

    );
}